// Copyright 2020 Drivetrain Hub LLC
// Helper functions for chart.js.

// eslint-disable-next-line no-unused-vars
import Chart from "chart.js";

/**
 * Callback function for chart.options.onResize event to maintain aspect ratio.
 * https://www.chartjs.org/docs/latest/axes/cartesian/linear.html#axis-range-settings
 * @param {Chart} chart - Chart object, automatically provided by onResize event.
 * @param {number} size - Chart size, automatically provided by onResize event.
 * @param {[number]} yLimits - Optionally specify y-axis limits, otherwise data limits are used.
 */
export function chartResize(chart, size, yLimits) {
  // compute chart aspect ratio based on chart area, not canvas size
  // canvas size includes things like padding from axes, so it is not good for maintaining aspect ratio
  const area = chart.chartArea;
  const width = area.right - area.left;
  const height = area.bottom - area.top;
  const aspectRatio = width / height;

  // get/set y-axis limits
  let yMin, yMax;
  if (!yLimits) {
    const yAxis = chart.scales['y-axis-0'];
    yMin = yAxis.min;
    yMax = yAxis.max;
  } else {
    [yMin, yMax] = yLimits;
    chart.options.scales.yAxes[0].ticks.min = yMin;
    chart.options.scales.yAxes[0].ticks.max = yMax;
  }

  // set x-axis limits
  const yRange = yMax - yMin;
  const xRange = yRange * aspectRatio;
  const xLimit = xRange / 2;
  chart.options.scales.xAxes[0].ticks.min = -xLimit;
  chart.options.scales.xAxes[0].ticks.max = xLimit;

  // DEV ONLY
  // console.log('chart', chart);
  // console.log('yRange', yRange);
  // console.log('xRange', xRange);
}
